import axios from 'axios'

export const state = {
  matrix: [],
  data: {},
  voiceMailStatistic: {}
}

export const getters = {
  getDataStats: state => { return state.matrix },
  getDataCount: state => state.data,
  voiceMailStatistic: state => state.voiceMailStatistic
}

export const mutations = {
  setDataStats (state, payload) { state.matrix = payload },
  setDataCount (state, payload) {
    state.data = payload
  },
  setVoiceMailStatistics (state, payload) {
    state.voiceMailStatistic = payload
  }
}

export const actions = {
  async loadDataStats ({ commit }, payload) {
    const uri = '/api/events-stats'
    await axios.get(uri)
        .then(response => { commit('setDataStats', response.data) })
        .catch(err => { console.log('Statistiques error ', err) })
  },
  async loadDataCount ({ commit }) {
    const uri = '/api/statistics'
    await axios.get(uri)
        .then(response => { commit('setDataCount', response.data) })
        .catch(err => { console.log('Statistiques error ', err) })
  },
  async loadVoiceMailStatistics ({ commit }, payload) {
    const uri = `/api/voice-mail-statistics/?period_start=${payload.period_start}&period_end=${payload.period_end}`
    await axios.get(uri)
        .then(response => { commit('setVoiceMailStatistics', response.data) })
        .catch(err => { console.log('Statistique voice mail error ', err) })
  }
}




// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/statistics.js